"use client";
import React, { useEffect } from "react";
import { useContext, useState } from "react";
const dataContext = React.createContext();

// Toast Notification
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useT } from "@/context/I18nContext";

export const useContextElement = () => {
	return useContext(dataContext);
};

export default function Context({ children }) {
	const [cartProducts, setCartProducts] = useState([]);
	const [wishList, setWishList] = useState([]);
	const [compareItem, setCompareItem] = useState([]);
	const [quickViewItem, setQuickViewItem] = useState([]);
	const [quickAddItem, setQuickAddItem] = useState(1);
	const [totalPrice, setTotalPrice] = useState(0);
	const [chatOpen, setChatOpen] = useState(false);
	const [voucherCode, setVoucherCodeState] = useState(null);
	const [voucherResult, setVoucherResult] = useState(null);
	
     const { t } = useT();

     useEffect(() => {
		const subtotal = cartProducts.reduce((accumulator, product) => {
			return accumulator + product.quantity * product.price;
		}, 0);
		setTotalPrice(subtotal);
	}, [cartProducts]);

	
	const isAddedToCartProducts = (id) => {
          const exists = cartProducts.some((item) => item.id === id);
		if (exists) {
               console.log('este in cos'); 
			return true;
		}
		return false;
	};

	const addToWishlist = (id) => {
		if (!wishList.includes(id)) {
			setWishList((pre) => [...pre, id]);
		} else {
			setWishList((pre) => [...pre].filter((elm) => elm != id));
		}
	};

     const addProductToCart = (id, qty) => {
          const exists = cartProducts.some((item) => item.id === id);

          if (exists) {
               setCartProducts((prev) => prev.filter((item) => item.id !== id));
               toast.info(t('toast_scos_cos'));
          } else {
               const item = {
                    id,
                    quantity: qty || 1,
               };
               setCartProducts((prev) => [...prev, item]);
               toast.success(t('toast_adaugat_cos'));
          }
     };

	const removeFromWishlist = (id) => {
		if (wishList.includes(id)) {
			setWishList((pre) => [...pre.filter((elm) => elm != id)]);
		}
	};
	const addToCompareItem = (id) => {
		if (!compareItem.includes(id)) {
			setCompareItem((pre) => [...pre, id]);
		}
	};
	const removeFromCompareItem = (id) => {
		if (compareItem.includes(id)) {
			setCompareItem((pre) => [...pre.filter((elm) => elm != id)]);
		}
	};
	const isAddedtoWishlist = (id) => {
		if (wishList.includes(id)) {
			return true;
		}
		return false;
	};
	const isAddedtoCompareItem = (id) => {
		if (compareItem.includes(id)) {
			return true;
		}
		return false;
	};
	useEffect(() => {
		const items = JSON.parse(localStorage.getItem("cartList"));
		if (items?.length) {
			setCartProducts(items);
		}
	}, []);

	useEffect(() => {
		localStorage.setItem("cartList", JSON.stringify(cartProducts));
	}, [cartProducts]);

	useEffect(() => {
		const items = JSON.parse(localStorage.getItem("wishlist"));
		if (items?.length) {
			setWishList(items);
		}
	}, []);

	useEffect(() => {
		localStorage.setItem("wishlist", JSON.stringify(wishList));
	}, [wishList]);

	useEffect(() => {
		const code = localStorage.getItem("voucherCode");
		if (code) setVoucherCodeState(code);
	}, []);

	const setVoucherCode = (code, result = null) => {
		setVoucherCodeState(code || null);
		setVoucherResult(result);

		if (code) {
			localStorage.setItem("voucherCode", code);
		} else {
			localStorage.removeItem("voucherCode");
		}
	};

	const clearVoucher = () => setVoucherCode(null, null);

	const contextElement = {
		cartProducts,
		setCartProducts,
		totalPrice,
		addProductToCart,
		isAddedToCartProducts,
		removeFromWishlist,
		addToWishlist,
		isAddedtoWishlist,
		quickViewItem,
		wishList,
		setQuickViewItem,
		quickAddItem,
		setQuickAddItem,
		addToCompareItem,
		isAddedtoCompareItem,
		removeFromCompareItem,
		compareItem,
		setCompareItem,
		chatOpen,
		setChatOpen,
		voucherCode,
		voucherResult,
		setVoucherCode,
		clearVoucher,
	};
	return (
		<dataContext.Provider value={contextElement}>
			{children}
		</dataContext.Provider>
	);
}
